import axios from "./axiosConfig";
import {
  getUploadUrl,
  uploadToS3,
  getViewUrl,
  downloadFolder,
} from "./filesService";
import {
  getDocumentS3Subfolder,
  getCapacitacionS3Subfolder,
  getExpedienteS3Prefix,
} from "../pages/Tecnicos/expedienteConstants";

const technicianExpedienteService = {
  async getExpediente(technicianId) {
    const response = await axios.get(`/technicians/${technicianId}/expediente`);
    return response.data.data;
  },

  async updatePersonal(technicianId, personalData) {
    const response = await axios.put(
      `/technicians/${technicianId}/expediente/personal`,
      personalData
    );
    return response.data.data;
  },

  async registerDocument(technicianId, docType, key, fileName) {
    const response = await axios.post(
      `/technicians/${technicianId}/expediente/documents`,
      { docType, key, fileName }
    );
    return response.data.data;
  },

  async updateCapacitacion(technicianId, capId, payload) {
    const response = await axios.put(
      `/technicians/${technicianId}/expediente/capacitaciones/${capId}`,
      payload
    );
    return response.data.data;
  },

  async uploadDocument(technicianId, docType, file) {
    const subfolder = getDocumentS3Subfolder(technicianId, docType);
    const { uploadUrl, key } = await getUploadUrl(file, subfolder);
    await uploadToS3(uploadUrl, file);
    return this.registerDocument(technicianId, docType, key, file.name);
  },

  async uploadCapacitacion(technicianId, capId, file) {
    const subfolder = getCapacitacionS3Subfolder(technicianId, capId);
    const { uploadUrl, key } = await getUploadUrl(file, subfolder);
    await uploadToS3(uploadUrl, file);
    return this.updateCapacitacion(technicianId, capId, {
      status: "completada",
      key,
      fileName: file.name,
    });
  },

  async getDocumentViewUrl(key) {
    const data = await getViewUrl(key);
    return data.url;
  },

  async downloadExpediente(technicianId) {
    const prefix = getExpedienteS3Prefix(technicianId);
    await downloadFolder(prefix);
  },
};

export default technicianExpedienteService;
